



























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class AppBarButtons extends Vue {
  @Prop({ type: Boolean, default: true })
  isShow!: boolean;

  @Prop({ type: Boolean })
  isCameraOn!: boolean;

  @Prop({ type: Boolean })
  isBlur!: boolean;

  @Prop({ type: Boolean })
  isCameraAvailable!: boolean;

  @Prop({ type: Boolean })
  isMicrophoneOn!: boolean;

  @Prop({ type: Boolean })
  isBlurAvailable!: boolean;

  get tooltipText() {
    if (!this.isCameraAvailable) {
      return this.$t("Camera not available");
    }
    return this.isCameraOn ? this.$t("Disable video") : this.$t("Enable video");
  }

  get audioTooltipText() {
    return this.isMicrophoneOn
      ? this.$t("Disable audio")
      : this.$t("Enable audio");
  }

  get blurTooltipText() {
    return this.isBlur
      ? this.$t("Disable background blur")
      : this.$t("Enable background blur");
  }

  @Emit()
  toggleCamera() {
    return !this.isCameraOn;
  }

  @Emit()
  toggleMicrophone() {
    return !this.isMicrophoneOn;
  }
  @Emit()
  toggleBlur() {
    return !this.isBlur;
  }
}
